import { Injectable } from '@angular/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { CurrencyFormat } from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class AppSettingService {
  currencyFormat: CurrencyFormat = 'symbol';
  matFormFieldAppearance: MatFormFieldAppearance = 'outline';
  useBrowserLocale = true;
}
